import * as Yup from 'yup';
import { PASSWORD_POLICY_REGEX, PASSWORD_POLICY_MESSAGE } from '../../../utils/passwordPolicy';

const hasTenPhoneDigits = (value) => {
    if (!value) {
        return false;
    }

    return value.replace(/\D/g, '').length === 10;
};

export const baseValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    middleName: Yup.string().nullable(),
    lastName: Yup.string().required('Last name is required'),
    addrNo: Yup.string().nullable(),
    addrUnit: Yup.string().nullable(),
    addrStreet: Yup.string().nullable(),
    addrCity: Yup.string().nullable(),
    addrProvince: Yup.string().nullable(),
    addrPostal: Yup.string().nullable(),
    addrCountry: Yup.string()
        .oneOf(['Canada', 'USA'], 'Country must be Canada or United States')
        .required('Country is required'),
    phone: Yup.string()
        .test('phone-format', 'Invalid phone number format', (value) => {
            if (!value) {
                return true;
            }

            return hasTenPhoneDigits(value);
        })
        .required('Phone number is required'),
    email: Yup.string()
        .email('Invalid email address')
        .required('Email address is required'),
    emergencyContactName1: Yup.string().nullable(),
    emergencyContactPhone1: Yup.string()
        .test('emergency-phone1-format', 'Invalid phone number format', (value) => {
            if (!value) {
                return true;
            }

            return hasTenPhoneDigits(value);
        })
        .nullable(),
    emergencyContactName2: Yup.string().nullable(),
    emergencyContactPhone2: Yup.string()
        .test('emergency-phone2-format', 'Invalid phone number format', (value) => {
            if (!value) {
                return true;
            }

            return hasTenPhoneDigits(value);
        })
        .nullable(),
    role: Yup.string().required('Role is required'),
});

export const newFormValidationSchema = baseValidationSchema.shape({
    password: Yup.string()
        .matches(PASSWORD_POLICY_REGEX, PASSWORD_POLICY_MESSAGE)
        .required('Password is required')
        .nullable(),
    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm password is required')
        .nullable(),
});

export const editFormValidationSchema = baseValidationSchema.shape({
    status: Yup.string().oneOf(["active", "inactive"]),
    password: Yup.string()
        .matches(PASSWORD_POLICY_REGEX, {
            message: PASSWORD_POLICY_MESSAGE,
            excludeEmptyString: true,
        })
        .nullable(),
    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .nullable(),
});

